import { motion } from 'motion/react'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const ProgressBar = styled.div`
  width: 100%;
  height: ${props => props.theme.size['3XS']};
  background-color: ${props => props.theme.colors.border.subtle};
  border-radius: ${props => props.theme.primitives.radius.radiusFull};
  overflow: hidden;
`

export const ProgressBarContent = styled(motion.div)`
  height: 100%;
  background-color: ${props => props.theme.colors.primary.default};
  border-radius: ${props => props.theme.primitives.radius.radiusFull};
`
